var chunkMapping = {
	"0": [
		4760
	],
	"3": [
		4213,
		5089
	],
	"74": [
		5171
	],
	"153": [
		5250
	],
	"154": [
		5251
	],
	"157": [
		5254
	],
	"158": [
		5255
	],
	"159": [
		5256
	],
	"160": [
		5257
	],
	"161": [
		5258
	],
	"162": [
		5259
	],
	"163": [
		5260
	],
	"164": [
		5261
	],
	"165": [
		5262
	],
	"166": [
		5263
	],
	"167": [
		5264
	],
	"168": [
		5265
	],
	"169": [
		5266
	],
	"170": [
		5267
	],
	"171": [
		5268
	],
	"172": [
		5269
	],
	"173": [
		5270
	]
};
var idToExternalAndNameMapping = {
	"4213": [
		"default",
		"./nuorder-components",
		3910
	],
	"4760": [
		"default",
		"./Containers",
		3820
	],
	"5089": [
		"default",
		"./helios-components",
		3910
	],
	"5171": [
		"default",
		"./OrderlessInvoices",
		3820
	],
	"5250": [
		"default",
		"./AsyncEventTracker",
		3820
	],
	"5251": [
		"default",
		"./HostWrapper",
		3820
	],
	"5254": [
		"default",
		"./CheckoutV3",
		3820
	],
	"5255": [
		"default",
		"./CheckoutConfirmation",
		3820
	],
	"5256": [
		"default",
		"./ContactCreditCards",
		3820
	],
	"5257": [
		"default",
		"./AuditDialog",
		3820
	],
	"5258": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3820
	],
	"5259": [
		"default",
		"./InvoiceDialog",
		3820
	],
	"5260": [
		"default",
		"./PaymentDueModal",
		3820
	],
	"5261": [
		"default",
		"./PaymentModal",
		3820
	],
	"5262": [
		"default",
		"./PaymentHistory",
		3820
	],
	"5263": [
		"default",
		"./PaymentConfigurations",
		3820
	],
	"5264": [
		"default",
		"./PaymentPreferences",
		3820
	],
	"5265": [
		"default",
		"./ManagePaymentProcessing",
		3820
	],
	"5266": [
		"default",
		"./MobilePaymentsWrapper",
		3820
	],
	"5267": [
		"default",
		"./Challenge",
		3820
	],
	"5268": [
		"default",
		"./ManagePaymentMethods",
		3820
	],
	"5269": [
		"default",
		"./LightspeedReports",
		3820
	],
	"5270": [
		"default",
		"./ShippingPromotionsListContainer",
		3820
	]
};
var idToRemoteMap = {
	"4213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3910
		}
	],
	"4760": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3910
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5250": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5251": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5254": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5255": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5256": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5257": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5258": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5259": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5260": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5261": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5262": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5263": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5264": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5265": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5266": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5267": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5268": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5269": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5270": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}